<template>
  <div>
    <b-modal visible no-close-on-backdrop no-close-on-esc hide-header-close hide-footer :id="theme" header-class="my-class" size="lg" title="ロコモ度テスト等">
      <div class="row">
        <div class="col-12">
          <div class="text-center">
            <span>患者ID: {{ user.patient_id }}</span>
            <span class="ms-3">患者名: {{ user.information?.fullname }}</span>
          </div>
        </div>
        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-4">
              <b-form-group>
                <label class="text-label"><b>KL分類（左脚）</b></label>
                <b-form-select class="form-select" v-model="selectedKLLeft" :options="klOptions" @input="clearError('all', selectedKLLeft)"></b-form-select>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label"><b>KL分類（右脚）</b></label>
                <b-form-select class="form-select" v-model="selectedKLRight" :options="klOptions" @input="clearError('all', selectedKLRight)"></b-form-select>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label">
                  <b>立ち上がりテスト</b>
                </label>
                <b-form-select class="form-select" v-model="selectedStandUpId" :options="standUpOptions" @input="clearError('all', selectedStandUpId)"></b-form-select>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label">ロコモ度</label>
                <b-form-input ref="input" type="text" disabled :value="selectedStandUpValue"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label">
                <b>WBI</b>
              </label>
              <b-form-input ref="input" type="text" disabled :value="selectedWbiValue"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>
        

        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label"><b>２ステップテスト（２回測定）</b></label>
                <div class="row g-2">
                  <div class="form-group-custom">
                    <div class="col-1 custome-mt">２歩幅</div>
                    <div class="col-2">
                      <input v-model.number="inputValueStep2" @input="removeErrorValueStep2()" type="number" class="form-control" id="numberInput" placeholder="" />
                    </div>
                    <div class="col-1 cm">cm</div>
                    <div class="col-1"></div>
                    <div class="col-1 custome-mt">身長</div>
                    <div class="col-2">
                      <input v-model.number="inputValueHeight" @input="removeErrorHeight()" type="number" class="form-control" id="numberInput" placeholder="" />
                    </div>
                    <div class="col-1 cm">cm</div>
                    <div class="col-1"></div>
                    <div class="col-2">
                      <button @click="addResultStep2" :disabled="exceededLimit" :class="{ 'disabled-button': exceededLimit }" class="btn submit-button">保存</button>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between" style="width: 450px">
                    <div v-if="showWarning" class="warning-text-1" style="width: 330px">数字を必ず入力してください。</div>
                    <div v-if="showWarningHeight" class="warning-text-1" style="width: 400px; text-align: right">数字を必ず入力してください。</div>
                  </div>
                  <div v-for="(result, numberOfResults) in results" :key="numberOfResults" class="form-group-custom">
                    <div class="col-10" style="font-size: 13px; text-align: left">
                      結果（ {{ numberOfResults + 1 }} 回目）：２歩幅 {{ result.foot_length }} cm ➗ 身長 {{ result.height }} cm = ２ステップ値 {{ result.value }}
                    </div>
                    <button @click="clearResult(numberOfResults)" class="clear-button">クリアー</button>
                  </div>
                  <div v-if="results.length > 0" style="margin-top: 15px; text-align: center; text-decoration: underline; font-weight: bold; font-size: 14px">
                    最終結果（最大値）：２ステップ値 {{ twoStepValue() }}
                  </div>
                </div>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label">ロコモ度</label>
                <b-form-input ref="input" type="text" disabled :value="twoStepResultBest()"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label"><b>ロコモ25</b></label>
                <div class="pt-2 custome-mt text-center border-bottom">{{ locomo25Score }}点</div>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label">ロコモ度</label>
                <b-form-input ref="input" type="text" disabled :value="locomo25Rank"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="pt-2 text-center border-bottom">
          <h5>その他のテスト</h5>
        </div>

        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label">
                  <b>5m歩行テスト</b>
                </label>
                <b-form-input ref="input" type="number" v-model.number="fiveMeter" disabled @input="clearError('all', fiveMeter)" maxlength="15"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label">&nbsp;</label>
                <b-button class="w-100 form-control" type="button" variant="light" @click="show5MeterTestModal" disabled>詳細表示</b-button>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label">
                  <b>痛みの評価：eVAS ※痛みの度合いを表した弊社独自の表記です。</b>
                </label>
                <b-form-input ref="input" type="text" :value="vas" @input="handleVasChange" maxlength="3" @keydown="handleKeyDown"> </b-form-input>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label">&nbsp;</label>
                <b-button class="w-100 form-control" type="button" variant="light" @click="showVasModal">詳細表示</b-button>
              </b-form-group>
            </div>
            <div class="cold-12 text-danger" v-if="!checkVas">eVASは0から100までを入力してください。</div>
          </div>
        </div>
        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label"><b>FIMの評価表</b></label>
                <b-form-input ref="input" type="text" v-model="fim" disabled @input="clearError('all', fim)"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label">&nbsp;</label>
                <b-button class="w-100 form-control" type="button" variant="light" @click="showFimModal">詳細表示</b-button>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="col-12 mt-1">
          <div class="row">
            <div class="col-8">
              <b-form-group>
                <label class="text-label"><b>BIの評価表</b></label>
                <b-form-input ref="input" type="text" v-model="bi" disabled @input="clearError('all', bi)"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-4">
              <b-form-group>
                <label class="text-label">&nbsp;</label>
                <b-button class="w-100 form-control" type="button" variant="light" @click="showBiModal">詳細表示</b-button>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div class="cold-12 text-danger font-size-14 text-center" v-if="errors.all">{{ errors.all }}</div>
        </div>
        <div class="col-12 font-size-12">
          参考文献 <br />
          2ステップテスト：村永信吾 他：昭和医学会誌,2003;63(3):301-308 <br />
          立ち上がりテスト：村永信吾：昭和医学会誌,2001;61(3):362-367
        </div>
      </div>

      <div class="pt-3">
        <RokomoTestBtns :disabled="disabled()" @close="closeModal()" @submit="submit()" />
      </div>

      <div v-if="fiveMeterAi">
        <div class="pt-3">
          <HokouAiResult :is-show="Boolean(fiveMeterAi)" :loading="false" :user="user" :result="fiveMeterAi" :firstResult="firstFiveMeterAi" :latestResult="latestFiveMeterAi" />
        </div>

        <div class="pt-3">
          <RokomoTestBtns :disabled="disabled()" @close="closeModal()" @submit="submit()" />
        </div>
      </div>
    </b-modal>

    <FiveMeterTest :isShow="opened5MeterTestModal" :user="user" @close="close5MeterTestModal" @save="save5MeterTest" />
    <vas :isShow="openedVasModal" :user="user" @close="closeVasModal" @submit="handleSubmitVas" />
    <Fim :isShow="openedFimModal" :user="user" :fimData="fimData" @close="closeFimModal" @submit="handleSubmitFim" />
    <Bi :isShow="openedBiModal" :user="user" :biData="biData" @close="closeBiModal" @submit="handleSubmitBi" />
  </div>
</template>

<script>
  import { userComputed, userMethods } from '@/state/helpers';
  import api from '@/api';
  import { mixin } from '@/helpers/Vue-Mixin';
  import FiveMeterTest from '@/pages/hospital/five-meter-test.vue';
  import vas from '@/pages/hospital/vas.vue';
  import Fim from '@/components/widgets/modal/edit-fim.vue';
  import Bi from  '@/components/widgets/modal/edit-bi.vue';
  import HokouAiResult from '@/components/widgets/hokou-ai.vue';
  import RokomoTestBtns from '@/components/widgets/rokomo-test-btns.vue';
  import { KL_CHOICES } from '@/constant';
  import {getProfile} from "../../../helpers/Auth";

  export default {
    mixins: [mixin],

    components: {
      FiveMeterTest,
      vas,
      Fim,
      Bi,
      HokouAiResult,
      RokomoTestBtns,
    },

    props: ['rokomo', 'user', 'theme'],

    data() {
      return {
        rokomoDataTest: {},

        standUpChoices: [],
        selectedStandUpId: null,
        selectedKLLeft: null,
        selectedKLRight: null,
        vas: '',
        checkVas: true,
        vasDisplay: 0,
        fiveMeter: '',
        selectedPatientId: '',
        selectedUser: {},
        errors: this.resetErrors(),
        opened5MeterTestModal: false,
        openedVasModal: false,
        openedFimModal: false,
        openedBiModal: false,
        locomo25: {},
        inputValueStep2: '',
        results: [],
        showWarningHeight: false,
        showWarning: false,
        showLimit: false,
        inputLimit: 2,
        enteredTimes: 0,
        fim: '',
        bi: '',
        dataFimToSend: [],
        dataBiToSend: [],
        two_step_data: [],
        five_meter_data: [],
        fiveMeterAi: null,
        firstFiveMeterAi: null,
        latestFiveMeterAi: null,
        locomo25Score: '',
        locomo25Rank: '',
        locomo25Id: '',
        fimAnswers: [],
        fimQuestions: [],
        fimData: [],
        biAnswers: [],
        biQuestions: [],
        biData: [],
        two_step: '',
        inputValueHeight: '',
        twoStep: '',
        userInfo: getProfile(),
      };
    },

    async created() {
      this.rokomoDataTest = JSON.parse(JSON.stringify(this.rokomo));
      await this.mapRokomoTestData();
      this.fetchDefaultValue();
    },

    computed: {
      ...userComputed,

      standUpOptions: function () {
        return this.standUpChoices.map((i) => ({ value: i.id, text: i.name }));
      },

      klOptions: function () {
        return JSON.parse(JSON.stringify(KL_CHOICES)).map((i) => ({ value: i.value, text: i.name }));
      },

      selectedStandUpValue: function () {
        return this.standUpChoices.find((i) => i.id === this.selectedStandUpId)?.value;
      },

      selectedWbiValue: function () {
        return this.standUpChoices.find((i) => i.id === this.selectedStandUpId)?.wbi;
      },

      exceededLimit() {
        return this.enteredTimes >= this.inputLimit;
      },
    },

    async mounted() {
      await this.refreshStandUpChoices();
      await this.refreshLatestSurveyScore();
    },

    watch: {
      fimAnswers: {
        async handler(value) {
          if (value.length > 0) {
            this.fimData = await this.handleProcessFimData();
          }
        },
      },

      biAnswers: {
        async handler(value) {
          if (value.length > 0) {
            this.biData = await this.handleProcessBiData();
          }
        },
      },

      fimData: {
        async handler(value){
          if(value.length > 0){
            const score = this.cumputeTotalScore(value);
            this.dataFimToSend = this.handleCreateFimSendData(value, score);
          }
        }
      },

      biData: {
        async handler(value){
          if(value.length > 0){
            const score = this.cumputeTotalScore(value);
            this.dataBiToSend = this.handleCreateBiSendData(value, score);
          }
        }
      }
    },

    methods: {
      ...userMethods,

      async mapRokomoTestData() {
        if (this.mapRokomoTestData) {
          await this.fetchFimQuestions();
          await this.fetchBiQuestions();
          await this.fetchFimAnswersById(this.rokomoDataTest.fim_survey_id);
          await this.fetchBiAnswersById(this.rokomoDataTest.bi_survey_id);
          this.selectedKLLeft = this.rokomoDataTest.kl_left;
          this.selectedKLRight = this.rokomoDataTest.kl_right;
          this.selectedStandUpId = this.rokomoDataTest.stand_up_choice_id;
          this.rokomoDataTest.stand_up_choice_value = this.selectedStandUpValue;
          this.showResultStep2(JSON.parse(this.rokomoDataTest.two_step_data));
          this.vas = this.rokomoDataTest.vas;
          this.locomo25Score = this.rokomoDataTest.locomo25_score;
          this.locomo25Rank = this.rokomoDataTest.locomo25_rank;
          this.locomo25Id = this.rokomoDataTest.locomo25_history_id;
          this.fim = this.rokomoDataTest.fim;
          this.bi = this.rokomoDataTest.bi;
          this.five_meter_data = this.rokomoDataTest.five_meter_data;
          this.fiveMeter = this.rokomoDataTest.five_meter;
          this.fiveMeterAi = this.rokomoDataTest.five_meter_ai;
          this.vasDisplay = this.vas;

          await this.getFirstAndLastResult();
        }
      },

      async fetchFimAnswersById(id) {
        try {
          const response = await api.getFimAnswersById(id);
          this.fimAnswers = response.data;
        } catch (error) {
          console.error(error);
          return {};
        }
      },

      async fetchBiAnswersById(id) {
        try {
          const response = await api.getBiAnswersById(id);
          this.biAnswers = response.data;
        } catch (error) {
          console.error(error);
        }
      },

      addResultStep2() {
        if (this.enteredTimes < this.inputLimit) {
          if (parseFloat(this.inputValueHeight) <= 0 || this.inputValueHeight == '') {
            this.showWarningHeight = true;
          }
          if (parseFloat(this.inputValueStep2) <= 0 || this.inputValueStep2 == '') {
            this.showWarning = true;
          }
          if (this.inputValueStep2 !== '' && this.inputValueHeight !== '' && parseFloat(this.inputValueHeight) > 0) {
            const resultValue = parseFloat(this.inputValueStep2) / parseFloat(this.inputValueHeight);
            this.results.push({
              value: resultValue.toFixed(2),
              height: this.inputValueHeight,
              foot_length: this.inputValueStep2,
            });
            const stepResult = {
              foot_length: this.inputValueStep2,
              height: this.inputValueHeight,
              result: resultValue.toFixed(2),
            };
            this.two_step_data.push(stepResult);
            this.showWarning = false;
            this.showWarningHeight = false;
            this.enteredTimes++;
            this.twoStepResultBest();
            this.twoStep = this.twoStepResult(resultValue);
            this.inputValueStep2='';
          }

        }
      },

      showResultStep2(twoStepData) {
        twoStepData.forEach((step_data) => {
          this.inputValueStep2 = step_data.foot_length;
          this.inputValueHeight = step_data.height ? step_data.height : step_data.Height;
          const resultValue = parseFloat(this.inputValueStep2) / parseFloat(this.inputValueHeight);
          this.results.push({
            value: resultValue.toFixed(2),
            height: this.inputValueHeight,
            foot_length: this.inputValueStep2,
          });
          this.two_step_data.push(step_data);
          this.twoStepResultBest();
          this.twoStep = this.twoStepResult(resultValue);
          this.enteredTimes++;
        });
        this.inputValueStep2='';
      },

      async fetchDefaultValue() {
        try {
            if (!this.inputValueHeight) {
                const response = await api.getMedicalByUserId(this.user.id);
                if (response.status === 200) {
                    this.inputValueHeight = response.data && response.data.height !== null ? response.data.height : "";
                } else {
                    this.inputValueHeight = "";
                }
              }
          } catch (error) {
              console.error('Error fetching default value:', error);
          }
      },

      clearResult(numberOfResults) {
        if (this.results.length > numberOfResults) {
          this.results.splice(numberOfResults, 1);
          this.clearVasData(numberOfResults);
          this.enteredTimes--;
          this.showLimit = false;
        }
      },

      removeErrorHeight() {
        this.showWarningHeight = false;
      },

      removeErrorValueStep2() {
        this.showWarning = false;
      },

      clearVasData(numberOfResults) {
        if (this.two_step_data.length > numberOfResults) {
          this.two_step_data.splice(numberOfResults, 1);
        }
      },

      resetErrors() {
        return {
          stand_up_choice_id: '',
          two_step: '',
          vas: '',
          five_meter: '',
          fim: '',
        };
      },

      async refreshStandUpChoices() {
        const res = await api.listStandUpChoices();
        this.standUpChoices = [{ id: null, name: '', value: null, wbi: null }, ...res.data];
      },

      async refreshLatestSurveyScore() {
        const res = await api.latestSurveyOfUser(this.userInfo.role.name,this.user.id, 2);
        this.locomo25 = res.data;
      },

      show5MeterTestModal() {
        this.opened5MeterTestModal = true;
      },

      close5MeterTestModal() {
        this.opened5MeterTestModal = false;
      },

      save5MeterTest(value, items, aiResult, firstAiResult, latestAiResult) {
        this.fiveMeter = value;
        this.five_meter_data = items;
        this.fiveMeterAi = aiResult;
        this.firstFiveMeterAi = firstAiResult;
        this.latestFiveMeterAi = latestAiResult;
      },

      showVasModal() {
        this.openedVasModal = true;
      },

      closeVasModal() {
        this.openedVasModal = false;
      },

      handleSubmitVas(vas) {
        this.vas = vas;
      },

      cumputeTotalScore(survey) {
        let sum = 0;
        survey.forEach((question) => {
          let score = question.answer === null || isNaN(question.answer) ? 0 : parseInt(question.answer);
          sum += score;
        });
        return sum;
      },

      handleSubmitFim(data) {
        const {data_answer, total_score} = data;
        this.fimData = data_answer;
        this.fim = total_score;
        this.clearError('all',  total_score);
        this.dataFimToSend = this.handleCreateFimSendData(data_answer, total_score);
      },

      async fetchFimQuestions() {
        try {
          const response = await api.getFimQuestion();

          if (response.status === 200) {
            this.fimQuestions = response.data;
          }

        } catch (error) {
          console.error('Error fetching default value:', error);
        }
      },

      async fetchBiQuestions(){
        try {
          const response = await api.getBiQuestion();

          if (response.status === 200) {
            this.biQuestions = response.data;
          }

        } catch (error) {
          console.error('Error fetching default value:', error);
        }
      },

      async handleProcessFimData() {
        let preCategoryValue = null;
        let preTypeValue = null;

        const questions = JSON.parse(JSON.stringify(this.fimQuestions));
        const answers = JSON.parse(JSON.stringify(this.fimAnswers));
        const processData = await Promise.all(
          answers.map(async (answer) => {
            let question = await questions.find((data) => data.id === answer.fim_question_id);

            question.answer_id = answer.id;
            question.answer = answer.answer;
            question.note = answer.note;
            question.choice = false;

            if (preCategoryValue !== question.category) {
              const choicesArray = questions.filter((i) => i.choices && i.category === question.category).map((question) => question.choices);
              const numberOfChoices = choicesArray && choicesArray[0] ? choicesArray[0].length : 0;
              question.category_rowspan = questions.filter((i) => i.category === question.category).length + numberOfChoices;
              preCategoryValue = question.category;
            } else {
              question.category_rowspan = 0;
            }

            if (preTypeValue !== question.type) {
              const choicesArray = questions.filter((i) => i.choices && i.type === question.type).map((question) => question.choices);
              const numberOfChoices = choicesArray && choicesArray[0] ? choicesArray[0].length : 0;
              question.type_rowspan = questions.filter((i) => i.type === question.type).length + numberOfChoices;
              preTypeValue = question.type;
            } else {
              question.type_rowspan = 0;
            }

            const choices = questions.filter((i) => i.choices && i.category === question.category && i.answer_id === question.answer_id).map((question) => question.choices);

            if (choices.length > 0) {
              let selectedChoice = answer.choices != null ? answer.choices : choices[0][0];
              question.choice = selectedChoice;
            }

            return question;
          })
        );
        return processData;
      },

      async handleProcessBiData() {
        const answers = JSON.parse(JSON.stringify(this.biAnswers));
        const questions = JSON.parse(JSON.stringify(this.biQuestions));

        const processData = await Promise.all(
          answers.map(async (answer) => {
            let question = await questions.find((data) => data.id === answer.bi_question_id);
            question.answer_id = answer.id;
            question.answer = answer.answer;

            return question;
          }
        ));

        return processData;
      },

      handleCreateFimSendData(fimData, total_score) {
        const answers = {};

        fimData.forEach((question, index) => {
          let score = question.answer ? parseInt(question.answer) : 0;
          let note = question.note || '';
          let choice = question.choice ? question.choice : '';
          let answer_id = question.answer_id? question.answer_id : undefined;
          let question_id = question.id? question.id : undefined;

          answers[index + 1] = {
            id: answer_id,
            score: score,
            note: note,
            choices: choice,
            question_id: question_id
          };
        });

        return {
          survey_id: this.rokomoDataTest.fim_survey_id,
          user_id: this.user.id,
          total_score: total_score,
          answers: answers,
        };
      },

      handleCreateBiSendData(biData, total_score){
        const answers = {};

        biData.forEach((question, index) => {
          let note = '';
          let score = question.answer === undefined ? '' : question.answer;
          let answer_id = question.answer_id ? question.answer_id : undefined;
          let question_id = question.id ? question.id : undefined;

          question.description.forEach((desc) => {
            if (desc.score == score) {
              note = desc.content;
            }
          });

          answers[index + 1] = {
            id: answer_id,
            score: score,
            note: note,
            question_id: question_id,
          };
        });

        if(this.selected === false && this.totalScore === 0){
          this.totalScore = '';
        }

        return {
          survey_id: this.rokomoDataTest.bi_survey_id,
          user_id: this.user.id,
          total_score: total_score,
          answers: answers,
        };
      },

      handleSubmitBi(data) {
        const {data_answers, total_score} = data;
        this.bi = total_score;
        this.biData = data_answers;
        this.clearError('all', total_score);
        this.dataBiToSend = this.handleCreateBiSendData(data_answers, total_score);
      },

      showBiModal() {
        this.openedBiModal = true;
      },

      closeBiModal() {
        this.openedBiModal = false;
      },

      handleVasChange(newValue) {
        this.vas = newValue;
        this.clearError('all', newValue);
        if (newValue < 0 || newValue > 100) {
          this.checkVas = false;
        } else {
          this.checkVas = true;
        }
      },

      async showFimModal() {
        this.openedFimModal = true;
      },

      closeFimModal() {
        this.openedFimModal = false;
      },

      twoStepValue() {
        const resultValues = this.results.map((result) => parseFloat(result.value));
        const maxResult = Math.max(...resultValues);
        if (isNaN(maxResult) || maxResult === -Infinity) {
          return null;
        }
        this.clearError('all', maxResult.toFixed(2));
        return maxResult.toFixed(2);
      },

      calculateTwoStepResult(value) {
        if (value === null) {
          return null;
        }

        if (value >= 1.1 && value < 1.3) {
          return 1;
        }

        if (value >= 0.9 && value < 1.1) {
          return 2;
        }

        if (value >= 0 && value < 0.9) {
          return 3;
        }

        return null;
      },

      twoStepResultBest() {
        const val = this.twoStepValue();
        return this.calculateTwoStepResult(val);
      },

      twoStepResult(resultValue) {
        return this.calculateTwoStepResult(resultValue);
      },

      resetModels() {
        this.selectedStandUpId = 0;
        this.vas = 0;
        this.fiveMeter = '';
      },

      closeModal() {
        this.$emit('close');
      },

      disabled() {
        let valid = false;
        if (this.selectedStandUpId === null && this.twoStepValue() === null && this.vas === '' && this.fiveMeter === '' && this.fim === '' && this.bi === '') {
          valid = true;
        }
        if (!this.checkVas) {
          valid = true;
        }
        return valid;
      },

      async submit() {
        if (!this.validated()) {
          return;
        }

        const defaultData = {
          survey_id: '',
          user_id: this.user.id,
          total_score: '',
          answers: {},
        };
        const fimData = this.dataFimToSend.length === 0 ? defaultData : this.dataFimToSend;
        const biData = this.dataBiToSend.length === 0 ? defaultData : this.dataBiToSend;
        const attributes = {
          id: this.rokomoDataTest.id,
          user_id: this.user.id,
          stand_up_choice_id: this.selectedStandUpId,
          stand_up_choice_value: this.selectedStandUpValue,
          locomo25_history_id: this.locomo25Id,
          locomo25_score: this.locomo25Score,
          locomo25_rank: this.locomo25Rank,
          two_step: this.twoStepValue(),
          vas: this.vas,
          five_meter: this.fiveMeter,
          fim: this.fim,
          two_step_data: JSON.stringify(this.two_step_data),
          five_meter_data: this.five_meter_data,
          five_meter_ai: this.fiveMeterAi,
          fim_survey_id: '',
          bi: this.bi,
          bi_survey_id: '',
          kl_left: this.selectedKLLeft,
          kl_right: this.selectedKLRight,
          fim_survey_id: this.rokomoDataTest.fim_survey_id,
          bi_survey_id: this.rokomoDataTest.bi_survey_id,
          fim_answers: fimData,
          bi_answers: biData,
        };

        try {
          await api.updateRokomoTest(attributes);
          window.toastr.success('テスト結果は正常に保存されました');
          this.resetModels();
        } catch (error) {
          window.toastr.error('ユーザー登録に失敗しました。');
        }

        this.$emit('eReloadRokomo');
        this.closeModal();
      },

      validated() {
        let valid = true;
        this.errors = this.resetErrors();
        if (!this.checkVas) {
          valid = false;
        }
        return valid;
      },

      clearError(field, value) {
        if (value !== null && value !== '' && value !== undefined) {
          this.errors[field] = '';
        }
      },

      handleKeyDown(event) {
        const key = event.key;
        if (!/^\d$|^Backspace$|^ArrowLeft$|^ArrowRight$|^ArrowUp$|^ArrowDown$|^Delete$/.test(key)) {
          event.preventDefault();
        }
      },

      async getFirstAndLastResult() {
        const res = await api.firstAndLast(this.user.id, this.rokomoDataTest.id);
        if (res.status === 200) {
          this.firstFiveMeterAi = res.data.first?.id === this.rokomoDataTest.id ? null : res.data.first?.five_meter_ai;
          this.latestFiveMeterAi = res.data.latest?.five_meter_ai;
        }
      }
    },
  };
</script>

<style scoped>
  ::v-deep .modal-title {
    display: block;
    width: 100%;
    text-align: center;
    padding: 1rem;
    font-weight: 700;
    color: #fff !important;
    font-size: 20px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  .form-group-custom {
    display: flex;
    align-items: center;
  }

  .custom-form-contral-step2 {
    width: 70px;
  }

  .result-step2 {
    display: inline;
  }

  .submit-button {
    height: 38px;
    width: 80px;
    border-radius: 5px;
    color: #ffffff;
    background-color: #8fc31f !important;
    border-color: #8fc31f !important;
  }

  .disabled-button {
    background-color: #666;
    color: #ccc;
    cursor: not-allowed;
  }

  .clear-button {
    height: 25px;
    width: 77px;
    margin-left: 2px;
    font-size: 10px;
    border-radius: 5px;
    color: #f46a6a;
    background-color: #ffffff !important;
    border-color: #f73838 !important;
    border-width: 1px;
    transition: background-color 0.3s, border-width 0.3s;
  }

  .clear-button:hover {
    background-color: #f46a6a !important;
    color: #ffffff !important;
    border-color: #ccc !important;
    border-width: 1px;
  }

  .warning-text-1 {
    color: #f46a6a;
  }

  .cm {
    text-align: center;
  }

  @media screen and (max-width: 992px) {
    .submit-button {
      /* margin-top: 10px; */
      height: 40px;
      width: 76px;
      border-radius: 5px;
      color: #ffffff;
      background-color: #8fc31f !important;
      border-color: #8fc31f !important;
    }

    .form-control {
      height: 40px;
      /* margin-top: 15px; */
    }

    .form-select {
      height: 40px;
      /* margin-top: 15px; */
    }

    .cm {
      margin-top: 10px;
    }

    .custome-mt {
      margin-top: 10px;
    }
  }
</style>
